package dev.danko.roblox_craft_ai.state

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import dev.danko.roblox_craft_ai.client.AdminApiClient
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import dev.danko.roblox_craft_ai.shared.model.AuthUserDto
import dev.danko.roblox_craft_ai.shared.model.UsageSummaryDto
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

/** Who is signed in, the server's auth mode, and whether the sign-in dialog is open. */
object AuthState {
    var user: AuthUserDto? by mutableStateOf(null)
        private set

    var required: Boolean by mutableStateOf(false)
        private set

    /** Invite-only phase: visitors who are not signed in only see the promo page, documents and sign-in. */
    var inviteOnly: Boolean by mutableStateOf(false)
        private set

    /** True once the server config and the current user are known; pages wait for it before the access check. */
    var ready: Boolean by mutableStateOf(false)
        private set

    var loginDialogOpen: Boolean by mutableStateOf(false)

    var usage: UsageSummaryDto? by mutableStateOf(null)
        private set

    var isAdmin: Boolean by mutableStateOf(false)
        private set

    /** Current billing plan id ("free", "starter", …) of the signed-in user. */
    var planId: String? by mutableStateOf(null)
        private set

    private val scope = MainScope()

    private var initialized = false

    suspend fun init() {
        if (initialized) return
        initialized = true
        RobloxCraftApiClient.onAuthRequired = { loginDialogOpen = true }
        RobloxCraftApiClient.onCreditsChanged = { if (user != null) scope.launch { refreshUsage() } }
        val config = RobloxCraftApiClient.getServerConfig()
        required = config?.authMode == "required"
        inviteOnly = config?.accessMode == "invite"
        user = RobloxCraftApiClient.currentUser()
        ready = true
        refreshUsage()
        isAdmin = AdminApiClient.isAdmin()
    }

    fun signedIn(newUser: AuthUserDto) {
        user = newUser
        loginDialogOpen = false
        scope.launch {
            refreshUsage()
            isAdmin = AdminApiClient.isAdmin()
        }
    }

    suspend fun signOut() {
        RobloxCraftApiClient.logout()
        user = null
        usage = null
        planId = null
        isAdmin = false
    }

    suspend fun refreshUsage() {
        usage = if (user != null) RobloxCraftApiClient.getUsage() else null
        planId = if (user != null) RobloxCraftApiClient.getBillingStatus()?.planId else null
    }
}
